import { PageRoutingRenderer } from './PageRoutingRenderer';

export default PageRoutingRenderer;
